import React from "react";
import '../App.css';
import '../blocks/customblocks';
import '../generator/generator';
import styles from "../styles/level1.module.css"
import instrLink from "../images/level0/instrLink.png"
import L2T0 from '../toolboxes/L2T0'
import L2T1 from '../toolboxes/L2T1'
import L2T2 from '../toolboxes/L2T2'
import BlocklyComponent from '../Blockly';
import level2Task0 from "../solutionxml/level2Task0";
import level2Task1 from "../solutionxml/level2Task1";
import level2Task2 from "../solutionxml/level2Task2"
import level2Task3 from "../solutionxml/level2Task3"


const level2 = () => {
  return (
    <div className={styles.container}>
    <main>
      <h1 className={styles.title}>
      Level 2: Variables {"&"} Types 
      </h1>
      <br></br>
      <div className={styles.center}>
        <h3 className={styles.instructions}> Task 0: First, create a variable called my_name and set it to a “” (string). Fill in the string with your name. Print the my_name variable to see your name!</h3>
      </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      
      toolbox = {L2T0}
      solutionXml = {level2Task0}
      >
      </BlocklyComponent>
    </div>
    <br></br>
    <div className={styles.center}>
        <h3 className={styles.instructions}> Task 1: Make another variable called temperature_of_day and set the variable to the temperature outside. Print temperature_of_day to see the number appear in the console!</h3>
      </div>
    <br></br>
    <div className={styles.right}>
      <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
        <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
      </a>
    </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      
      toolbox = {L2T1}
      solutionXml = {level2Task1}
      >
      </BlocklyComponent>
    </div>
    <br></br>
      <div className={styles.center}>
        <h3 className={styles.instructions}> Task 2: Make a new variable called is_it_raining_outside and set it too set to true or false (depending on whether it is raining outside). Print is_it_raining to see the value! </h3>
      </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      
      toolbox = {L2T2}
      solutionXml = {level2Task2}
      >
      </BlocklyComponent>
    </div>
    <br></br>
      <div className={styles.center}>
        <h3 className={styles.instructions}> Task 3: Use two variables named x and y and set them equal to two DIFFERENT numbers of your choice. Next, use the print button to see if x == y. Essentially, come up with a math expression that is FALSE and check if it prints out false!</h3>
      </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      
      toolbox = {L2T2}
      solutionXml = {level2Task3}
      >
      </BlocklyComponent>
    </div>
  </main>
  </div>
  );
}
  
export default level2;